import { render, staticRenderFns } from "./BuyWashRequest.vue?vue&type=template&id=12a49b76&scoped=true"
import script from "./BuyWashRequest.vue?vue&type=script&lang=js"
export * from "./BuyWashRequest.vue?vue&type=script&lang=js"
import style0 from "./BuyWashRequest.vue?vue&type=style&index=0&id=12a49b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a49b76",
  null
  
)

export default component.exports